<template>
	<div class="wrap">
		<myHead></myHead>
		<div class="wrap_body" v-loading="isLoading">
			<div class="main_head">
				<div class="center">
					<div class="page_links">
						当前位置：
						<el-breadcrumb separator-class="el-icon-arrow-right">
							<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
							<el-breadcrumb-item>供求信息</el-breadcrumb-item>
						</el-breadcrumb>
					</div>
				</div>
			</div>
			<div class="main_content center">
				<div class="input-wrap">
					<textarea @input="onInput" v-model="content" class="input-area" :disabled="!userinfo" cols="30" rows="10" placeholder="留下你的脚印~" v-if="userinfo"></textarea>
					<div class="btn-login-wrap" v-if="!userinfo">
						<div class="ttt">请您注册或者登录星好货账号即可发布信息</div>
						<div class="btn_wrap">
							<p class="btn-go-login" @click.self="openLoginMask();">登录</p>
							<p class="btn-go-register" @click.self="openRegisterMask();">免费注册</p>
						</div>
					</div>
					<div class="send-wrap" v-if="userinfo">
						<div class="count-num">{{content.length}}/500</div>
						<div class="send-btn" v-loading="posting" @click="submit">发表</div>
					</div>
				</div>
				<div class="message-wrap">
					<div class="message-title">供求信息 {{total}}</div>
					<div class="message-list">
						<div class="message-item" v-if="total > 0" v-for="(item,index) in list" :key="index">
							<div class="send-nickname">{{item.nickname}}</div>
							<div class="send-date">{{item.date_str}}</div>
							<div class="send-content">{{item.content}}</div>
						</div>
					</div>
					<div class="message-empty" v-if="total == 0 && nomore">目前还没有内容，欢迎发表留言</div>
					<div class="message-loadmore" v-if="total > 0 && !nomore" @click="getPageList">展开更多</div>
					<div class="message-nomore" v-if="total > 0 && nomore">已经到底了</div>
				</div>
			</div>
		</div>
		<loginRegister ref="loginRegister" @refresh="loginRefresh()"></loginRegister>
		<myFoot showBeian></myFoot>
	</div>
</template>

<script>
import Vue from 'vue';
import myHead from '../../components/myHead/myhead';
import myFoot from '../../components/myFoot/myfoot';
import loginRegister from '../../components/loginRegister/loginRegister';
import { mapActions,mapState,mapMutations } from "vuex";
export default {
	name: "communicate",
	data() {
		return {
			isLoading:false,
			page_size:8,
			page:1,
			content:'',
			list:[],
			userinfo:"",
			nomore: false,
			total: 0,
			loading: false,
			posting: false,
		}
	},
	components:{
		myHead,myFoot,loginRegister
	},
	
	created(){
		this.userinfo = this.users?this.users:""
		console.log(this.userinfo)
		this.$nextTick(function () {
			this.getPageList()
		})
	},
	computed:{
		...mapState({
			users:(state)=>state.login.userinfo,
			avatars:(state)=>state.login.avatar
		}),
	},
	methods: {
		...mapActions({
			opMessageSubmit:"ucenter/opMessageSubmit",
			getMessageList:"ucenter/getMessageList",
		}),
		loginRefresh(){
			this.userinfo = this.users
			this.avatar = this.avatars || headDefault
		},
		openLoginMask(){//打开登录弹窗
			this.$refs.loginRegister.openLoginMask()
		},
		openRegisterMask(){
			this.$refs.loginRegister.openRegisterMask()
		},//打开注册弹窗
		onInput(e){
			if(this.content.length > 500){
				this.content = this.content.slice(0,500)
			}
		},
		submit(){
			if(this.posting) return
			this.posting = true
			this.opMessageSubmit({data:{content:this.content},success:(res) => {
				this.posting = false
				if(res.code == 200){
					this.$message({message: res.msg,type: 'success'});
					this.content = ''
					this.page = 1
					this.getPageList()
				}else{
					this.$message({message: res.msg,type: 'error'});
					setTimeout(function(){
						location.reload()
					},1000)
				}
			}})
		},
		getPageList(){//获取单页列表
			if(this.loading) return
			this.loading = true
			this.getMessageList({data:{limit:20,page:this.page},success:(res) => {
				this.loading = false
				if(res.code == 200){
					let list = res.data.data
					// console.log('获取单页列表',res)
					if(this.page == 1){
						this.list = list
					}else{
						this.list = this.list.concat(list)
					}
					this.total = res.data.total
					if(this.list.length == res.data.total){
						this.nomore = true
					}else{
						this.nomore = false
					}
					this.page ++
				}
			}})
		},
		

		
	}
}
</script>
<style scoped>
.wrap{background: #fff;}
.center{display: flex;align-items: flex-start;}
.main_head .center{flex-direction: column;}
.main_head{width: 100%;height: 90px;border-bottom: 1px solid #eee;position: sticky;top: 98px;z-index: 99;background: #fff;}
.page_links{line-height: 1;font-size: 14px;color: #999999;display: flex;margin-top: 25px;}
.main_content{margin-bottom: 40px;padding-top: 30px;display: flex;flex-direction: column;}
.main_content .input-wrap{position: relative;width: 100%;height: 180px;border: solid 1px #cccccc;}
.main_content .input-area{width: 100%;height: 180px;padding: 20px;font-size: 14px;text-align: justify;}
.main_content .btn-login-wrap{position: absolute;width: 100%;left: 0;top: 70px;display: flex;flex-direction: 
column;align-items: center;justify-content: center;cursor: pointer;}
.main_content .btn-login-wrap .ttt{font-size: 14px;color: #787878;}
.btn_wrap{display: flex;align-items: center;justify-content: center;}
.btn-go-login{width: 100px;height: 38px;background-color: #fa5757;border-radius: 4px;font-size: 14px;display: flex;align-items: center;justify-content: center;color: #fff;margin-top: 30px;margin-left: 5px;margin-right: 5px;}
.btn-go-register{width: 100px;height: 38px;background-color: #fff;border:1px solid #fa5757;border-radius: 4px;font-size: 14px;display: flex;align-items: center;justify-content: center;color: #fa5757;margin-top: 30px;margin-left: 5px;margin-right: 5px;}
.main_content .send-wrap{display: flex;align-items: center;position: absolute;right: 10px;bottom: 10px;}
.main_content .send-wrap .count-num{font-size: 14px;color: #999999;}
.main_content .send-wrap .send-btn{width: 60px;height: 28px;background-color: #fa5757;border-radius: 4px;font-size: 12px;color: #ffffff;display: flex;align-items: center;justify-content: center;cursor: pointer;margin-left: 10px;}
.main_content .message-wrap{display: flex;flex-direction: column;margin-top: 40px;width: 100%;}
.main_content .message-wrap .message-title{font-size: 16px;color: #333333;font-weight: bold;}
.main_content .message-wrap .message-empty{font-size: 14px;color: #666666;margin: 70px auto;}
.main_content .message-wrap .message-loadmore{font-size: 14px;color: #666666;margin: 30px auto;cursor: pointer;}
.main_content .message-wrap .message-loadmore:hover{color: #fa5757;}
.main_content .message-wrap .message-nomore{font-size: 14px;color: #999999;margin: 30px auto;}
.message-list{display: flex;flex-direction: column;width: 100%}
.message-list .message-item{display: flex;flex-direction: column;width: 100%;position: relative;padding: 30px 0;border-bottom: 1px solid #eee;}
.message-list .message-item .send-nickname{font-size: 14px;color: #333333;font-weight: bold;}
.message-list .message-item .send-content{font-size: 14px;color: #3a3a3a;line-height: 26px;margin-top: 20px;text-align: justify;}
.message-list .message-item .send-date{position: absolute;right: 0px;color: #787878;font-size: 12px;}
</style>
<style>
.page_links .el-breadcrumb__inner{font-weight: bold !important;color: #333 !important;}
.page_links .el-breadcrumb__inner.is-link{font-weight: initial !important;color: #999 !important;}
.page_links .el-breadcrumb__inner.is-link:hover{color: #f0423f !important;text-decoration: underline;}
</style>